// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQs-module--root--HFloJ","faqContainer":"FAQs-module--faqContainer--2uWgm"};